<script lang="ts">
  import BannerBase from "@retailer/svelte/Payments/Banners/Base.svelte";

  const reactivationBannerType = "reactivation_payment_settings_banner";

</script>

<div class="fizz-flex-item fizz-stack-16" data-testid={reactivationBannerType}>
  <div class="fizz-alert-info">
    <p><strong>ProviPay account reactivated</strong></p>
    <p class="fizz-text-medium fizz-stack-4">
      As a security precaution, one of your payment methods was removed and your auto pay settings
      may have been impacted. Please check your payment method below before rescheduling your
      payments or signing up for autopay.
    </p>
  </div>
</div>
